import { render, staticRenderFns } from "./PartsList.vue?vue&type=template&id=4712df3c&lang=pug"
import script from "./PartsList.vue?vue&type=script&lang=js"
export * from "./PartsList.vue?vue&type=script&lang=js"
import style0 from "./PartsList.vue?vue&type=style&index=0&id=4712df3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports